function RatingWidget(props) {
	const { schema, value, required, onChange } = props;
	const { title, enum: list, enumNames: names } = schema;

	return (
		<div className="form-group">
			<label className="form-label">{title}{required && "*"}</label>
			<div className="rating-wrapper">
				<div className="rating-numbers-wrapper">
					{
						list.map(val => (
							<p>{val}</p>
						))
					}
				</div>
				<hr style={{ margin: "2px 0px" }} />
				<div className="rating-input-wrapper">
					{
						list.map(val => (
							<input
								className="form-check-inline"
								value={val}
								type="radio"
								onChange={(e) => onChange(e.target.value)}
								checked={val === value}
							/>
						))
					}
				</div>
				<p className="rating-label-names"><span>{names[0]}</span><span>{names[names.length - 1]}</span></p>
			</div> 
		</div>
	)
}

export default RatingWidget;